import { useState, useEffect } from 'react';

// Armazenar step globalmente para compartilhar entre componentes
let globalStep = 1;
const listeners = new Set<(step: number) => void>();

export function useStep(defaultStep: number = 1) {
  const [step, setStepState] = useState(globalStep || defaultStep);

  // Sincronizar com globalStep
  useEffect(() => {
    // Sempre sincronizar com o step atual, garantindo que seja um número válido
    if (typeof step === 'number' && step > 0) {
      globalStep = step;
    } else {
      globalStep = defaultStep;
    }
  }, [step, defaultStep]);

  // Adicionar listener para mudanças globais
  useEffect(() => {
    const listener = (newStep: number) => setStepState(newStep);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const setStep = (n: number) => {
    globalStep = n;
    listeners.forEach(l => l(n));
    setStepState(n);
  };

  return { step, setStep };
}
